module.exports = __webpack_public_path__ + "files/d5314bd441da46076e380889eaea87ba.png";